export default {"src":"/_next/static/media/reforestation_illustration.37755d8e.svg","height":244,"width":300};